export const cilLoopCircular = ["24 24","<path d='M19.468 16.814c1.709-1.709 2.621-3.995 2.568-6.438-0.057-2.51-1.098-4.765-2.751-6.405l-0.001-0.001-1.061 1.060c1.389 1.377 2.264 3.27 2.313 5.367l0 0.009c0.044 2.030-0.712 3.929-2.131 5.348l-2.28 2.301v-4.179h-1.5v6.75h6.753v-1.5h-4.2z'></path><path d='M2.247 5.25h4.2l-2.29 2.311c-1.709 1.709-2.621 3.995-2.568 6.438 0.057 2.51 1.098 4.765 2.751 6.405l0.001 0.001 1.061-1.060c-1.389-1.377-2.264-3.27-2.313-5.367l-0-0.009c-0.044-2.030 0.712-3.929 2.131-5.347l2.279-2.297v4.179h1.5l0.001-6.754h-6.753z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-loop-circular.js
// module id = null
// module chunks = 